import BX from 'BX';
import {InputBase} from './components/InputBase';
import {createAutocomplete, VueAutocomplete} from './VueAutocomplete';

/** @typedef { import("./Autocomplete").AutocompleteDataset } AutocompleteDataset */

/**
 * @typedef {object} AddressSuggestion
 * @property {string} value
 * @property {string} unrestricted_value
 */

let url;

/**
 * @param {string} newUrl
 */
export function setUrl(newUrl) {
    url = newUrl;
}

/**
 * @returns {AutocompleteDataset}
 */
const getDataset = () => ({
    source: (query, cb) => {
        /**
         * @param {object} data
         * @param {AddressSuggestion[]} data.suggestions
         */
        const done = ({suggestions}) => {
            cb(suggestions);
        }

        $.get(url, {query})
            .done(done);
    },
    debounce: 250,
    cache: true,
});

const autocompleteOptions = {
    autoselect: true,
    autoselectOnBlur: true,
    hint: false,
    tabAutocomplete: true,
    minLength: 3,
}

export const InputDadataAddress = {
    mixins: [VueAutocomplete],
    props: {
        initialError: String,
        defaultCity: String,
        value: String,
        name: String,
        label: String,
    },
    data: function () {
        return ({
            error: this.initialError,
        });
    },
    methods: {
        initAutocomplete() {
            return createAutocomplete(this.$refs.input, this.$options.autocompleteOptions, this.$options.autocompleteDatasets);
        },
        /**
         *
         * @param {Event} event
         */
        checkCity(event) {
            /** @type {HTMLInputElement} */
            const target = event.target;
            /** @type {string} */
            const city = this.defaultCity;
            /** @type {string} */
            const value = target.value;
            const regexp = new RegExp(`^(г )?${city}([, ](.+)?)?$`);

            if (regexp.test(value)) {
                target.setCustomValidity('');
                this.error = '';
            } else {
                target.setCustomValidity('Указан неверный город');
                this.error = 'Указан неверный город';
            }
        },
    },
    created() {
        const dataset = getDataset();

        this.$options.autocompleteOptions = Object.assign(this.$options.autocompleteOptions, autocompleteOptions);
        this.$options.autocompleteDatasets.push(dataset);
    },
    mounted() {
        this.$options.autocomplete.on('autocomplete:selected', (event) => this.checkCity(event));
    },
    render(h) {
        return (
            <InputBase
                type="text"
                ref="input"
                value={this.value}
                name={this.name}
                label={this.label}
                onInput={this.checkCity}
                onChange={this.checkCity}
            >
                {this.error ? (
                    <p class="text-danger mt-1" slot="after">{this.error}</p>
                ) : null}
            </InputBase>
        );
    }
}

export function registerComponent() {
    const isRegistered = Vue.component('input-dadata-address');

    if (!isRegistered)
        Vue.component('input-dadata-address', InputDadataAddress);
}

BX.namespace('DadataAddress');

BX.DadataAddress.init = function () {
    registerComponent();

    document
        .querySelectorAll('[is="input-dadata-address"]')
        .forEach((elem) => new Vue({el: elem}));
}

BX.DadataAddress.setUrl = setUrl;
